import AboutTemplate from "../../components/about/AboutTemplate";
import Page from "../Page";
import { Link, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import ResponsiveImage from "../../components/about/ResponsiveImage";
import Section from "../../components/about/Section";

const Tasks = () => {
  return (
    <Page
      className="about-page tasks-information-page"
      pageKey="tasks-information"
    >
      <AboutTemplate>
        <Section>
          <Typography variant="h1">Tasks</Typography>
          <Typography variant="p1">
            Tasks are a "unit" of work in Mindstack. Think of them as a single
            job, which once done, can be ticked off your to-do list.
          </Typography>

          <ResponsiveImage imageName="task" pageKey="tasks" size="large" />
        </Section>

        <Typography variant="p1">
          Mindstack will display your tasks in a stack and prioritise them, so
          you can easily focus on the tasks which are most important to you.
        </Typography>

        <Typography variant="p1">
          Add{" "}
          <Link
            component={RouterLink}
            to="/about/features/tasks/attributes"
            variant="p1"
          >
            attributes
          </Link>{" "}
          to tasks to give you more control over where tasks will appear in your
          to-do list and help you target tasks based on your{" "}
          <Link
            component={RouterLink}
            to="/about/features/mindset"
            variant="p1"
          >
            mindset
          </Link>
          .
        </Typography>

        <Typography variant="p1">
          <Link
            component={RouterLink}
            to="/about/features/task-targeting"
            variant="p1"
          >
            Target a task
          </Link>{" "}
          to set a task as a goal and commit to focussing on it until it is
          complete.
        </Typography>

        <Typography variant="p1">
          <Link
            component={RouterLink}
            to="/about/features/tasks/labels"
            variant="p1"
          >
            Labels
          </Link>{" "}
          can be added to tasks to group tasks together and{" "}
          <Link
            component={RouterLink}
            to="/about/features/task-filtering"
            variant="p1"
          >
            filter
          </Link>{" "}
          tasks based on their label.
        </Typography>

        <Typography variant="p1">
          Add{" "}
          <Link
            component={RouterLink}
            to="/about/features/tasks/deadlines"
            variant="p1"
          >
            deadlines
          </Link>{" "}
          to tasks to help make sure you get your tasks done on time. Tasks can
          also be made to{" "}
          <Link
            component={RouterLink}
            to="/about/features/tasks/recurring-tasks"
            variant="p1"
          >
            recur
          </Link>{" "}
          if they frequently re-appear on your to-do list.
        </Typography>

        <Typography variant="p1">
          <Link
            component={RouterLink}
            to="/about/features/tasks/notes"
            variant="p1"
          >
            Notes
          </Link>{" "}
          can be added to tasks to keep hold of information relevant to your
          task
        </Typography>
      </AboutTemplate>
    </Page>
  );
};

export default Tasks;
